export const config = {
    rowSelection: false,
    fieldControl: false,
    columns: [
        {title: 'ID', dataIndex: 'id', width: 200},
        {title: '权益图标', dataIndex: 'imageUrl', width: 200, render: 'iconRender'},
        {title: '权益名称', dataIndex: 'name', width: 200, ellipsis: true},
        {title: '权益类型', dataIndex: 'equityCategoryName', width: 200, ellipsis: true},
        {title: '权益描述', dataIndex: 'description', width: 200, ellipsis: true},
        {title: '状态', dataIndex: 'state', width: 200, render: 'switchRender'},
        {title: '排序', dataIndex: 'orderSeq', width: 120,},
        {title: '最后更新人', dataIndex: 'modifiedByName', width: 200,},
        {title: '最后更新时间', dataIndex: 'lastUpdatedTime', width: 200, itemType: 'dateTime'},
        {title: '操作', dataIndex: 'action', fixed: 'right', width: 120, render: 'actionRender'},
    ],
    search: [
        {label: '权益名称', name: 'name'},
        {label: '状态', name: 'state', itemType: 'select', key: 'value', data: 'stateList'},
        {label: '权益类型', name: 'equityCategoryId', itemType: 'tree', data: 'equityCategoryList',  fieldNames: {label: 'name', value: 'id', children:'childList'},},
    ],
    footer: [
        {label: '新增', type: 'primary', events: ['onClick:onAdd']}
    ]
}
